import React, { useContext } from 'react';
import { EventContext } from '../../../../../pages/Activity/context/EventProvider';
import { SECTION_TYPES } from './constants';

import './TodayEventDisplay.scss';

export default function TodayEventDisplay({ events, todayDate }) {
  const { getEventFontColor } = useContext(EventContext);

  const year = todayDate.getFullYear();
  const month = todayDate.getMonth();
  const dayOfMonth = todayDate.getDate();
  const dayStartUTC = Date.UTC(year, month, dayOfMonth, 0, 0, 0, 0);
  const dayEndUTC = Date.UTC(year, month, dayOfMonth, 23, 59, 59, 999);

  const isLeave = subject =>
    typeof subject === 'string' && subject.toLowerCase().includes('leave');

  const overlapsDay = (startISO, endISO) => {
    const s = Date.parse(startISO);
    const e = Date.parse(endISO);
    return e >= dayStartUTC && s <= dayEndUTC;
  };

  const formatTimeUTC = iso => iso.slice(11, 16); // "HH:mm"
  const formatDateUTC = iso => {
    const date = new Date(iso);
    const d = String(date.getUTCDate()).padStart(2, '0');
    const m = String(date.getUTCMonth() + 1).padStart(2, '0');
    return `${d}-${m}`;
  };

  const isSameUTCDate = (iso, y, m, d) => {
    const dt = new Date(iso);
    return (
      dt.getUTCFullYear() === y &&
      dt.getUTCMonth() === m &&
      dt.getUTCDate() === d
    );
  };

  // Toggle this to hide timing on middle days
  const SHOW_MIDDLE_DAY_TIMES = true; // set to false if you want no timing on middle days

  // Generic label for the Today section (applies to ALL events)
  const buildTodayLabel = ev => {
    const start = new Date(ev.StartTime);
    const end = new Date(ev.EndTime);

    const isMultiDay =
      start.getUTCFullYear() !== end.getUTCFullYear() ||
      start.getUTCMonth() !== end.getUTCMonth() ||
      start.getUTCDate() !== end.getUTCDate();

    if (!isMultiDay) {
      return `${formatTimeUTC(ev.StartTime)} to ${formatTimeUTC(ev.EndTime)}`;
    }

    const isStartDay = isSameUTCDate(ev.StartTime, year, month, dayOfMonth);
    const isEndDay = isSameUTCDate(ev.EndTime, year, month, dayOfMonth);

    if (isStartDay) {
      return `${formatTimeUTC(ev.StartTime)} to 23:59`;
    }
    if (isEndDay) {
      return `00:00 to ${formatTimeUTC(ev.EndTime)}`;
    }

    // middle day
    return SHOW_MIDDLE_DAY_TIMES ? '00:00 to 23:59' : '';
  };

  const todayEvents = events.filter(ev =>
    overlapsDay(ev.StartTime, ev.EndTime),
  );

  const vacationEvents = events.filter(
    ev => isLeave(ev.Subject) && overlapsDay(ev.StartTime, ev.EndTime),
  );

  const otherEvents = events.filter(
    ev =>
      overlapsDay(ev.StartTime, ev.EndTime) &&
      !isLeave(ev.Subject) &&
      !todayEvents.includes(ev),
  );

  const renderItem = (ev, isToday) => {
    const fontColor = getEventFontColor(ev);

    const dateTimeLabel = isToday
      ? buildTodayLabel(ev)
      : `${formatDateUTC(ev.StartTime)} to ${formatDateUTC(ev.EndTime)}`;

    return (
      <li key={ev.EventID} className="event-list-item">
        <span
          className="subject"
          style={{ color: fontColor }}
          title={ev.Subject}
        >
          {ev.Subject}
        </span>
        {dateTimeLabel ? (
          <span className="time-label">{dateTimeLabel}</span>
        ) : null}
      </li>
    );
  };

  const renderSection = (title, list) => (
    <div key={title} className="section-container">
      <div
        className={`d-flex align-items-center gap-2 mb-2 ${
          title !== 'Today' ? 'mt-3' : ''
        }`}
      >
        {SECTION_TYPES?.[title]?.icon && (
          <img
            src={SECTION_TYPES?.[title]?.icon}
            className="section-icon"
            alt="section icon"
          />
        )}
        <span className="section-title">
          {SECTION_TYPES?.[title]?.label(todayDate)}
        </span>
      </div>

      {list.length > 0 ? (
        list.map(ev => (
          <div className="mb-1" key={ev.EventID}>
            {renderItem(ev, title === 'Today')}
          </div>
        ))
      ) : (
        <p className="no-events">No events</p>
      )}
    </div>
  );

  return (
    <div className="today-event-display">
      {true && renderSection('Today', todayEvents)}
      {renderSection('Vacation', vacationEvents)}
      {renderSection('Others', otherEvents)}
    </div>
  );
}
